import React, { useEffect, useRef, useState } from 'react';
import { RotateCcw } from 'lucide-react';
import { Button } from './ui/button';

export const CampaignVideoSection = ({ id, label, src, fallbackSrc, poster }) => {
  const section = useRef(null);
  const video = useRef(null);
  const [mediaSource, setMediaSource] = useState();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    // Load each clip only as its player approaches the viewport.
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        const supportsMp4 = video.current.canPlayType('video/mp4; codecs="avc1.640028"');
        setMediaSource(supportsMp4 ? src : fallbackSrc);
        observer.disconnect();
      }
    }, { rootMargin: '240px' });
    observer.observe(section.current);
    return () => observer.disconnect();
  }, [src, fallbackSrc]);

  const retry = () => {
    setFailed(false);
    video.current?.load();
  };

  return (
    <div ref={section} className="campaign-video-section rounded-2xl shadow-lg" aria-label={label} data-testid={`${id}-section`}>
      <video
        ref={video}
        src={mediaSource}
        poster={poster}
        className="campaign-video-player"
        aria-label={label}
        muted
        playsInline
        controls
        preload="metadata"
        onError={() => setFailed(true)}
        onLoadedData={() => setFailed(false)}
        data-testid={id}
      >
        Your browser does not support this video.
      </video>
      {failed && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-black px-6 text-center text-white" role="alert" data-testid={`${id}-error`}>
          <p data-testid={`${id}-error-message`}>This video couldn’t load.</p>
          <Button type="button" onClick={retry} className="bg-white text-navy hover:bg-cream" data-testid={`${id}-retry`}>
            <RotateCcw size={16} /> Retry video
          </Button>
          <a href={mediaSource || src} target="_blank" rel="noopener noreferrer" className="text-sm underline underline-offset-4" data-testid={`${id}-open-original`}>Open video</a>
        </div>
      )}
    </div>
  );
};